export const SITE_NAME = 'Unique Diamond Horse Sanctuary'
export const DEFAULT_SITE_URL = 'https://uniquediamondhorsesanctuary.org/'

const configuredSiteUrl = import.meta.env.VITE_SITE_URL?.trim()

const normalizeSiteUrl = (value: string) => {
  try {
    const url = new URL(value)
    if (!['http:', 'https:'].includes(url.protocol) || url.hostname === 'localhost') {
      return DEFAULT_SITE_URL
    }
    url.hash = ''
    url.search = ''
    if (!url.pathname.endsWith('/')) url.pathname += '/'
    return url.toString()
  } catch {
    return DEFAULT_SITE_URL
  }
}

export const SITE_URL = normalizeSiteUrl(configuredSiteUrl || DEFAULT_SITE_URL)

export const absoluteUrl = (path = '/') => {
  const cleanPath = path === '/' ? '' : path.replace(/^\/+/, '')
  return new URL(cleanPath, SITE_URL).toString()
}

export const canonicalPath = (path: string) => {
  const withoutQuery = path.split(/[?#]/, 1)[0] || '/'
  if (withoutQuery === '/index.html' || withoutQuery === '') return '/'
  const trimmed = withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, '') : withoutQuery
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

